export const projectsPath = "/projects";
export const aboutPath = "/about";
export const contactPath = "/contact";
export const mementoMoriPath = "/mementomori";
export const snapchatPath = "/snapchat";
export const miroPath = "/miro";
export const newsletterPath = "/newsletter";
export const upreachPath = "/upreach";